import {environment} from 'src/environments/environment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class MenuAiChatService {
  endpoint = environment.apiUrl;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  constructor(private http: HttpClient) {}

  sendMessage(storeId: string, payload: { message: string; conversation_id?: string; dry_run?: boolean }) {
    return this.http.post<{
      message: string;
      actions: { tool: string; args: any; result: any }[];
      dry_run: boolean;
      conversation_id: string;
    }>(`${this.endpoint}/backend/v2/master-menu/agent/chat/?store=${storeId}`, payload, this.httpOptions);
  }
}
